import { useEffect } from "react";
import { motion } from "framer-motion";

const LegalLayout = ({ title, lastUpdated, children }) => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen py-8 sm:py-12 md:py-20 px-4 sm:px-6 md:px-12 lg:px-24" data-testid={`legal-${title.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <h1 
              className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-3 sm:mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {title}
            </h1>
            {lastUpdated && (
              <p className="text-xs sm:text-sm text-[#888888]">
                Last updated: {lastUpdated}
              </p>
            )}
          </div>

          {/* Content */}
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-5 sm:p-8 md:p-12 border border-[#E2E2E2]/50">
            {children}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LegalLayout;
